import React from 'react';
import { logoUrl } from '../data/mock';

const Logo = ({ className = "w-10 h-10" }) => {
  return (
    <img 
      src={logoUrl} 
      alt="White Shiba Inu" 
      className={className}
    />
  );
};

export default Logo;
